// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { useEffect, useState } from 'react';

import { Logo } from '../Logo';
import styles from './SagerLogo.module.css';

/** The phone breakpoint every Sager stylesheet uses (56.25rem). */
const PHONE_QUERY = '(max-width: 56.25rem)';
/** The wordmark's cap height in CSS px: 4–5× the bar's 14, less on a phone. */
const WORDMARK_SIZE = 64;
const WORDMARK_SIZE_PHONE = 40;

function usePhone(): boolean {
  const [phone, setPhone] = useState(() => typeof matchMedia === 'function' && matchMedia(PHONE_QUERY).matches);
  useEffect(() => {
    if (typeof matchMedia !== 'function') return;
    const query = matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return phone;
}

/** The animated wordmark, large, heading the case list (Sager has no bar). */
export function SagerWordmark() {
  const phone = usePhone();
  return (
    <div className={styles.wordmark}>
      <Logo variant="word" size={phone ? WORDMARK_SIZE_PHONE : WORDMARK_SIZE} playOnMount />
    </div>
  );
}
